<template>
  <div>
    <Aguarde :show="showAguarde"></Aguarde>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <div class="card-body">
            <b-form>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="CPF" label-for="pes_cpfcnpj">
                    <h5 class="mb-3">{{ pessoa.pes_cpfcnpj | VMask('###.###.###-##') }}</h5>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Nome Completo" label-for="pes_nome">
                    <input class="form-control" v-model="pessoa.pes_nome"
                           :class="{ 'is-invalid': $v.pessoa.pes_nome.$error }"
                           id="pes_nome" type="text">
                    <div v-if="$v.pessoa.pes_nome.$error" class="invalid-feedback">
                      Informe seu nome completo
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Data de Nascimento" label-for="pes_datanascimento">
                    <input v-model="pessoa.pes_datanascimento" id="pes_datanascimento"
                           :class="{ 'is-invalid': $v.pessoa.pes_datanascimento.$error }"
                           type="date" class="form-control"/>
                    <div v-if="$v.pessoa.pes_datanascimento.$error" class="invalid-feedback">
                      Informe a data
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="Núm. RG" label-for="pes_rg">
                    <input class="form-control"
                           :class="{ 'is-invalid': $v.pessoa.pes_rg.$error }"
                           v-model="pessoa.pes_rg" id="tps_rg" type="text">
                    <div v-if="$v.pessoa.pes_rg.$error" class="invalid-feedback">
                      Informe número do RG
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Órgão emissor RG" label-for="pes_orgaoemissor">
                    <input class="form-control"
                           :class="{ 'is-invalid': $v.pessoa.pes_orgaoemissor.$error }"
                           v-model="pessoa.pes_orgaoemissor" id="pes_orgaoemissor"
                           type="text">
                    <div v-if="$v.pessoa.pes_orgaoemissor.$error" class="invalid-feedback">
                      Informe o Órgão emissor
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group label="Natureza Jurídica" label-for="eco_natureza_juridica">
                    <select id="eco_natureza_juridica" :class="{ 'is-invalid': $v.pessoa.eco_natureza_juridica.$error }"
                            v-model="pessoa.eco_natureza_juridica.naj_codigo" class="custom-select">
                      <option value=""></option>
                      <option v-for="t in natureza_juridica" v-bind:value="t.naj_codigo"
                              v-bind:key="t.naj_codigo">
                        [{{ t.naj_referencia }}] {{ t.naj_descricao }}
                      </option>
                    </select>
                    <div v-if="$v.pessoa.eco_natureza_juridica.$error" class="invalid-feedback">
                      Informe a natureza jurídica
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <b-form-group label="Sexo" label-for="pes_sexo">
                    <select id="pes_sexo" v-model="pessoa.pes_sexo" class="custom-select"
                            :class="{ 'is-invalid': $v.pessoa.pes_sexo.$error }">
                      <option value=""></option>
                      <option v-for="t in listSexo" v-bind:value="t.tab_codigo"
                              v-bind:key="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                    <div v-if="$v.pessoa.pes_sexo.$error" class="invalid-feedback">
                      Informe o sexo
                    </div>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="PIS/PASEP" label-for="pes_pispasep">
                    <input v-model="pessoa.pes_pispasep" v-mask="'###.#####.##.#'" id="pes_pispasep"
                           type="text"
                           class="form-control"/>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Título eleitoral" label-for="pes_tituloeleitor">
                    <input v-model="pessoa.pes_tituloeleitor" class="form-control" id="pes_tituloeleitor"
                           v-mask="'####.####.####'" type="text">
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Estado Civil" label-for="pes_estadocivil">
                    <select id="pes_estadocivil" v-model="pessoa.pes_estadocivil" class="custom-select">
                      <option value=""></option>
                      <option v-for="t in listEstadoCivil" v-bind:value="t.tab_codigo"
                              v-bind:key="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Nível de Escolaridade" label-for="pes_grauescolar">
                    <select id="pes_grauescolar" v-model="pessoa.pes_grauescolar" class="custom-select">
                      <option value=""></option>
                      <option v-for="t in listEscolaridade" v-bind:value="t.tab_codigo"
                              v-bind:key="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-5">
                  <b-form-group label="Classe Profissional" label-for="pes_sociedade_classe">
                    <select id="pes_sociedade_classe" v-model="pessoa.pes_sociedade_classe"
                            class="custom-select">
                      <option value=""></option>
                      <option v-for="t in listClasseProfissional" v-bind:value="t.tab_codigo"
                              v-bind:key="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-md-3">
                  <b-form-group label="Núm. Reg de Classe" label-for="pes_numero_registro_classe">
                    <input class="form-control" v-model="pessoa.pes_numero_registro_classe"
                           id="pes_numero_registro_classe" type="text">
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <b-form-group label="Situação" label-for="tab_107situacao">
                    <select id="tab_107situacao" @change="alteraStatus(pessoa.tab_107situacao)"
                            v-model="pessoa.tab_107situacao"
                            class="custom-select" type="text">
                      <option value="1002">Nula</option>
                      <option value="1003">Ativa</option>
                      <option value="1004">Suspensa</option>
                      <option value="1005">Inapta</option>
                      <option value="1006">Ativa Não Regular</option>
                      <option value="1007">Baixada</option>
                    </select>
                  </b-form-group>
                </div>
                <div v-if="pessoa.tab_107situacao !== '1003'" class="col-md-5">
                  <b-form-group label="Motivo da Situação" label-for="tab_108motivo_situacao">
                    <select id="tab_108motivo_situacao"
                            :class="{'is-invalid': tab_108motivo_situacaoInvalid }"
                            v-model="pessoa.tab_108motivo_situacao"
                            class="custom-select" type="text">
                      <option v-for="t in tab_grupo_108" v-bind:key="t.tab_codigo" v-bind:value="t.tab_codigo">
                        {{ t.tab_nome }}
                      </option>
                    </select>
                    <div v-if="tab_108motivo_situacaoInvalid" class="invalid-feedback">
                      Informe um motivo para situação diferente de ativa
                    </div>
                  </b-form-group>
                </div>
              </div>
            </b-form>
            <div class="row">
              <div class="col-6">
                <b-form-group class="mt-3 text-left">
                  <button type="button"
                          @click="voltar"
                          title="Salvar dados da pessoa"
                          class="btn btn-dark">
                    <i class="bx bx-arrow-back"></i> Voltar
                  </button>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group class="mt-3 text-right">
                  <button type="button"
                          @click="saveDadosPessoa()"
                          title="Salvar dados da pessoa"
                          class="btn btn-success">
                    <i class="bx bx-check-double"></i> Salvar dados da pessoa
                  </button>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
<script>
import {required} from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import Loader from "@/components/widgets/loader";
import Aguarde from "@/components/widgets/aguarde";
import {getDadosEmpresa, putDadosEmpresa} from "@/api/admin/gestao/empresas";
import {notifySucesso, notifyErro} from "@/helps/notificacao";
import {getTabSelecoes} from "@/api/geral/helps";

export default {
  components: {
    Loader,
    Aguarde
  },
  props: {
    eco_codigo: {
      type: Number,
      required: true
    },
    natureza_juridica: {
      type: Array,
      required: true
    },
    listSexo: {
      type: Array,
      required: true
    },
    listEstadoCivil: {
      type: Array,
      required: true
    },
    listEscolaridade: {
      type: Array,
      required: true
    },
    listClasseProfissional: {
      type: Array,
      required: true
    },
  },
  computed: {},
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      showAguarde: false,
      httpSend: false,
      cpfCnpjInvalid: false,
      pessoa: {
        eco_codigo: null,
        pes_codigo: null,
        pes_cpfcnpj: "",
        pes_nome: "",
        pes_rg: "",
        pes_orgaoemissor: "",
        pes_sexo: "",
        pes_pispasep: "",
        pes_tituloeleitor: "",
        pes_estadocivil: "",
        pes_grauescolar: "",
        pes_sociedade_classe: "",
        pes_numero_registro_classe: "",
        pes_datanascimento: null,
        eco_natureza_juridica: {
          naj_codigo: null
        },
        tab_107situacao: null,
        tab_108motivo_situacao: null,
      },
      tab_108motivo_situacaoInvalid: false,
      tab_grupo_108: [],
    };
  },
  validations: {
    pessoa: {
      pes_nome: {
        required,
      },
      pes_rg: {
        required,
      },
      pes_orgaoemissor: {
        required,
      },
      pes_datanascimento: {
        required,
      },
      pes_sexo: {
        required,
      },
      eco_natureza_juridica: {
        required,
      }
    }
  },
  created() {
    this.getDados();
  },
  methods: {
    labelNaturezaJuridica({naj_referencia, naj_descricao}) {
      return `[${naj_referencia}] ${naj_descricao}`
    },
    alteraStatus(tab_107situacao) {
      this.getTabGrupo108();
      const new_tab_107situacao = parseInt(tab_107situacao)
      if (new_tab_107situacao === 1003) {
        Swal.fire({
          title: "Termo de responsabilidade",
          html: 'Declaro que as pendências que motivaram a suspensão deste econômico foram plenamente sanadas e que a empresa está apta a emitir documentos fiscais de serviço.',
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Ciente",
          cancelButtonText: "Cancelar"
        }).then(result => {
          if (!result.isConfirmed) {
            this.getDados()
          }
        });
      }
    },
    getDados() {
      this.httpSend = true;
      getDadosEmpresa(this.eco_codigo).then(result => {
        if (result.status) {
          this.pessoa = result.dados;
          this.getTabGrupo108();
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    saveDadosPessoa() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }
      this.tab_108motivo_situacaoInvalid = false;
      if (this.pessoa.tab_107situacao !== '1003') {
        if (!this.pessoa.tab_108motivo_situacao) {
          this.tab_108motivo_situacaoInvalid = true;
          return false;
        }
      }
      this.showAguarde = true;
      putDadosEmpresa(this.eco_codigo, this.pessoa).then(result => {
        if (result.status) {
          notifySucesso("DattaNFSe", result.mensagem)
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.showAguarde = false;
      })
    },
    getTabGrupo108() {
      if (this.pessoa.tab_108motivo_situacao === '1003') {
        return
      }
      if (this.tab_grupo_108.length > 0) {
        return;
      }
      getTabSelecoes(108).then(result => {
        if (result.status) {
          this.tab_grupo_108 = result.dados.grupo108;
        } else {
          notifyErro("DattaNFSe", result.mensagem)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    voltar() {
      this.$router.back();
    }
  }
};
</script>

